// services/InitialStateService.js
import { fetchWithAuth } from './api';

class InitialStateService {
  async getInitialState(userId) {
    try {
      let url = '/api/initialstate';
      if (userId) {
        url += `?userId=${userId}`; // backend kan läsa userId från query
      }
      const response = await fetchWithAuth(url);
      if (response.status === 404) {
        // Inget state finns ännu
        return null;
      }
      if (!response.ok) {
        throw new Error('Failed to get initial state');
      }
      return await response.json();
    } catch (error) {
      console.error('Error getting initial state:', error);
      return null;
    }
  }

  async setDbState(field, value, userId) {
    let url = '/api/initialstate';
    if (userId) {
      url += `?userId=${userId}`; // backend kan läsa userId från query
    }
    const response = await fetchWithAuth(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ field, value })
    });

    if (!response.ok) {
      throw new Error(`Failed to update ${field}`);
    }

    return response.json();
  }
}

export default new InitialStateService();